import HttpService from "./httpService";

class EntityService {

    getEntity = async () => {
        return HttpService.get<{_id: string,entityId: number, isActive: boolean, storeUrl: string, email: string, name: string, mobile: string}>('/entity');
    }

    updateEntityStoreUrl = async ({storeUrl}: {storeUrl: string}) => {
        return HttpService.patch('/entity/store-url', { storeUrl });
    }

    updateEntityStoreStatus = async (status: boolean) => {
        return HttpService.patch('/entity/store-status', { status });
    }

    updateEntityMobileNumber = async (mobile: string) => {
        return HttpService.patch('/entity/mobile', { mobile });
    }
}

export const entityService  = new EntityService();